// extracted by mini-css-extract-plugin
module.exports = {"banner":"_3_vOdO","closeButton":"_73o-H-","text":"_11isUs","lowerText":"_1RUFEU","button":"_1I7TKD","row":"fcb0aq","col":"_1yGy_x"};